import axios from 'axios';

const API_URL = '/api/v1/task/';

const checkTask = (id) => axios.get(`${API_URL}${id}`);

export { checkTask };
